import type { CustomErrorRule } from '@/core/error/transport/types'
import type { InternalErrorResponse } from '@/services/transport/types'
import { TmAuthPendingFraudError } from '@/core/error/transport/auth/TmAuthPendingFraudError'

type AccountSuspendedErrorResponse = InternalErrorResponse & { status?: string }

export const authAccountSuspendedErrorRule: CustomErrorRule = {
  subCodes: ['auth.account_suspended'],
  klass: TmAuthPendingFraudError,
  predicateFn: (error) => (error.response.data as AccountSuspendedErrorResponse).status === 'P',
}
